import { Alert, Modal, Form, Input, Descriptions } from '@pankod/refine-antd'
import React, { useCallback, useState } from 'react'

import { CalonPesertaDidikResponse } from '@resources/pendaftaran-diklat/types'

type UseRejectReasonModalState = CalonPesertaDidikResponse

export const useRejectReasonModal = () => {
  const [selectedPeserta, setSelectedPeserta] =
    useState<CalonPesertaDidikResponse | null>(null)

  const onClose = useCallback(() => {
    setSelectedPeserta(null)
  }, [])

  return {
    show: (peserta: UseRejectReasonModalState) => {
      setSelectedPeserta(peserta)
    },
    onClose,
    peserta: selectedPeserta,
  }
}

type ModalRejectReasonProps = {
  peserta: CalonPesertaDidikResponse | null
  onClose: () => void
  onConfirm: (id: string, reason: string) => Promise<void>
}

const ModalRejectReason = ({
  onClose,
  peserta,
  onConfirm,
}: ModalRejectReasonProps) => {
  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      setIsLoading(true)
      if (peserta) {
        await onConfirm(peserta.id, values.rejectReason)
        onClose()
      }
    } catch {
      // Validation failed or API error
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      visible={!!peserta}
      title="Tolak Peserta Didik"
      okText="Tolak"
      okButtonProps={{ danger: true, loading: isLoading }}
      cancelText="Batal"
      onCancel={onClose}
      onOk={handleOk}
      destroyOnClose
      afterClose={() => form.resetFields()}
      width={600}
    >
      <Descriptions
        size="small"
        column={1}
        bordered
        labelStyle={{ width: '100px' }}
        className="!mb-4"
      >
        <Descriptions.Item label="Nama">{peserta?.nama}</Descriptions.Item>
        <Descriptions.Item label="Email">{peserta?.email}</Descriptions.Item>
      </Descriptions>

      <Form form={form} layout="vertical">
        <Alert
          className="!mb-4"
          type="info"
          showIcon
          message="Alasan penolakan yang Anda isi akan ditampilkan kepada pengguna akhir."
        />
        <Form.Item
          name="rejectReason"
          label="Alasan Penolakan"
          rules={[
            { required: true, message: 'Alasan penolakan wajib diisi' },
            { min: 10, message: 'Alasan penolakan minimal 10 karakter' },
          ]}
          tooltip="Berikan alasan yang jelas dan spesifik untuk penolakan pendaftaran ini. Minimal 10 karakter."
        >
          <Input.TextArea
            rows={4}
            placeholder="Contoh: Dokumen pendukung tidak memenuhi standar yang ditentukan..."
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ModalRejectReason
